import type { Feedback } from '@/shared/domain'
import { Badge } from '@/shared/ui/primitives'

const SOURCE_LABEL: Record<NonNullable<Feedback['source']>, string> = {
  web: 'Web',
  mobile: 'Mobile',
}

export type FeedbackSourceBadgeProps = {
  source: Feedback['source']
}

export function FeedbackSourceBadge({ source }: FeedbackSourceBadgeProps) {
  if (!source) return null
  return <Badge variant="secondary">{SOURCE_LABEL[source]}</Badge>
}
